import { render, staticRenderFns } from "./AgeStep.vue?vue&type=template&id=0320dae9"
import script from "./AgeStep.vue?vue&type=script&lang=js"
export * from "./AgeStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports